export const createPreBillStyles = (paperWidth: number, commonStyles: string) => `
  ${commonStyles}

  body {
    padding: ${paperWidth === 58 ? '1mm 2mm 1mm 0' : '4mm 4mm 4mm 0'};
    font-weight: 600;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    overflow: hidden;
  }

  .receipt-header {
    text-align: center;
    margin-bottom: 2mm;
    border-bottom: 2px solid black;
    padding-bottom: 1mm;
  }

  .restaurant-name {
    font-size: ${paperWidth === 58 ? '13px' : '16px'};
    font-weight: 900;
    margin-bottom: 1mm;
    letter-spacing: ${paperWidth === 58 ? '0.5px' : '1px'};
  }

  .restaurant-info {
    font-size: ${paperWidth === 58 ? '9px' : '11px'};
    line-height: 1.4;
    font-weight: 600;
  }

  .bill-title {
    text-align: center;
    font-size: ${paperWidth === 58 ? '14px' : '18px'};
    font-weight: 900;
    margin: ${paperWidth === 58 ? '1mm' : '2mm'} 0;
    padding: ${paperWidth === 58 ? '1mm' : '2mm'} 0;
    border-top: 3px double black;
    border-bottom: 3px double black;
    letter-spacing: ${paperWidth === 58 ? '1px' : '2px'};
  }

  .order-info {
    font-size: ${paperWidth === 58 ? '10px' : '12px'};
    margin-bottom: ${paperWidth === 58 ? '1mm' : '2mm'};
    line-height: 1.2;
    font-weight: ${paperWidth === 58 ? '600' : '700'};
  }

  .order-info-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.5mm;
  }
  
  .order-info-row strong {
    font-weight: 900;
  }

  .divider {
    border-top: 1px dashed black;
    margin: ${paperWidth === 58 ? '1.5mm' : '2mm'} 0;
  }

  .person-header {
    font-size: ${paperWidth === 58 ? '12px' : '13px'};
    font-weight: 900;
    text-align: left;
    border-bottom: 2px solid black;
    letter-spacing: 0.5px;
  }

  .item-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: ${paperWidth === 58 ? '0.5mm' : '1mm'};
    margin-bottom: 0.5mm;
    page-break-inside: avoid;
  }

  .item-main {
    display: flex;
    align-items: flex-start;
    gap: ${paperWidth === 58 ? '0.5mm' : '1mm'};
    flex: 1;
  }

  .item-qty {
    font-size: ${paperWidth === 58 ? '12px' : '14px'};
    font-weight: 900;
    min-width: ${paperWidth === 58 ? '5mm' : '8mm'};
    flex-shrink: 0;
  }

  .item-name {
    font-size: ${paperWidth === 58 ? '11px' : '13px'};
    font-weight: ${paperWidth === 58 ? '600' : '700'};
    flex: 1;
    line-height: 1.1;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .item-price {
    font-size: ${paperWidth === 58 ? '11px' : '13px'};
    font-weight: 900;
    text-align: right;
    white-space: nowrap;
    flex-shrink: 0;
    min-width: ${paperWidth === 58 ? '10mm' : '15mm'};
  }

  .item-category {
    font-size: ${paperWidth === 58 ? '9px' : '10px'};
    font-weight: 900;
    color: #000;
    margin-left: ${paperWidth === 58 ? '6mm' : '9mm'};
    margin-bottom: ${paperWidth === 58 ? '0.5mm' : '1mm'};
    font-style: italic;
  }

  .totals-section {
    margin-top: ${paperWidth === 58 ? '1mm' : '2mm'};
    border-top: 2px solid black;
    padding-top: ${paperWidth === 58 ? '1mm' : '2mm'};
  }

  .total-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: ${paperWidth === 58 ? '0.5mm' : '1mm'};
    font-size: ${paperWidth === 58 ? '11px' : '13px'};
    font-weight: ${paperWidth === 58 ? '600' : '700'};
  }

  .total-row.final {
    font-size: ${paperWidth === 58 ? '13px' : '14px'};
    font-weight: 900;
    margin-top: 1mm;
    padding-top: 1mm;
    border-top: 3px double black;
    letter-spacing: 0.5px;
  }

  .footer {
    text-align: center;
    margin-top: 2mm;
    padding-top: ${paperWidth === 58 ? '1mm' : '2mm'};
    border-top: 1px dashed black;
    font-size: ${paperWidth === 58 ? '9px' : '10px'};
  }
`;

export const createReceiptStyles = (paperWidth: number, commonStyles: string) => `
  ${commonStyles}

  body {
    padding: 4px;
    font-size: ${paperWidth === 58 ? '11px' : '12px'};
    font-weight: 700;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .receipt-header {
    text-align: center;
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 2px solid black;
  }

  .restaurant-name {
    font-size: ${paperWidth === 58 ? '16px' : '18px'};
    font-weight: 900;
    margin-bottom: 4px;
  }

  .restaurant-info {
    font-size: ${paperWidth === 58 ? '10px' : '11px'};
    line-height: 1.4;
  }

  .receipt-info {
    margin: 8px 0;
    font-size: ${paperWidth === 58 ? '10px' : '11px'};
  }

  .receipt-info-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2px;
  }

  .receipt-divider {
    border-top: 1px dashed black;
    margin: 8px 0;
  }

  .receipt-items {
    margin: 8px 0;
  }

  .items-table {
    width: 100%;
    border-collapse: collapse;
  }

  .items-table th {
    text-align: left;
    font-size: ${paperWidth === 58 ? '10px' : '11px'};
    font-weight: 900;
    padding: 4px 2px;
    border-bottom: 1px solid black;
  }

  .items-table th.text-right {
    text-align: right;
  }

  .receipt-item td {
    padding: 4px 2px;
    vertical-align: top;
    font-size: ${paperWidth === 58 ? '10px' : '11px'};
  }

  .item-quantity {
    width: 15%;
    text-align: center;
    font-weight: 900;
  }

  .item-description {
    width: 65%;
  }

  .item-name {
    font-weight: 900;
    margin-bottom: 2px;
  }

  .item-category {
    font-size: ${paperWidth === 58 ? '9px' : '10px'};
    font-weight: bold;
    color: #666;
    margin-top: 1px;
  }

  .item-total {
    text-align: right;
    width: 20%;
    font-weight: 900;
  }

  .person-section td {
    padding: 6px 2px 4px 2px;
  }

  .person-header {
    font-weight: 900;
    font-size: 12px;
    text-align: center;
    background: #f0f0f0;
    border-top: 1px solid black;
    border-bottom: 1px solid black;
  }

  .receipt-totals {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid black;
  }

  .total-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
    font-size: ${paperWidth === 58 ? '11px' : '12px'};
    font-weight: 700;
  }

  .total-row.grand-total {
    font-size: ${paperWidth === 58 ? '14px' : '16px'};
    font-weight: 900;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 2px solid black;
  }

  .receipt-payment {
    margin-top: 12px;
    padding-top: 8px;
    border-top: 1px dashed black;
  }

  .payment-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
    font-size: 12px;
    font-weight: 700;
  }

  .payment-row.change {
    font-weight: 900;
    margin-top: 4px;
  }

  .receipt-footer {
    text-align: center;
    margin-top: 16px;
    padding-top: 8px;
    border-top: 2px solid black;
    font-size: 11px;
  }

  .footer-message {
    margin-top: 8px;
    font-weight: 900;
  }
`;
